import Cargos from '@/models/Cargos'

export default [
  {
    path: '/administrativo/usuarios',
    name: 'rota-usuarios',
    autenticado: true,
    cargo: [Cargos.ADMINISTRADOR],
    titulo: 'Usuários',
    layout: 'LayoutBarraLateral',
    menu: {
      label: 'Usuários',
      icon: 'user',
    },
    component: () => import(/* webpackChunkName: "usuarios" */ '../views/usuarios/Usuarios.vue'),
  },
  {
    path: '/administrativo/usuario/cadastro',
    name: 'rota-usuarios-cadastro',
    autenticado: true,
    cargo: [Cargos.ADMINISTRADOR],
    titulo: 'Cadastro usuários',
    layout: 'LayoutBarraLateral',
    component: () => import(/* webpackChunkName: "usuarios" */ '../views/usuarios/cadastro/UsuariosCadastro.vue'),
  },
  {
    path: '/administrativo/usuarios/:id',
    name: 'rota-usuarios-alteracao',
    autenticado: true,
    cargo: [Cargos.ADMINISTRADOR],
    titulo: 'Alteração usuários',
    layout: 'LayoutBarraLateral',
    component: () => import(/* webpackChunkName: "usuarios" */ '../views/usuarios/cadastro/UsuariosCadastro.vue'),
  },
  {
    path: '/perfil/alterar',
    name: 'rota-perfil-alteracao',
    autenticado: true,
    titulo: 'Alteração de dados',
    layout: 'LayoutBarraLateral',
    component: () => import(/* webpackChunkName: "usuarios" */ '../views/usuarios/alterar-dados/AlterarDadosUsuarios.vue'),
  },
]
